import { Form } from "react-bootstrap";

/**
 * @param {object} props
 * @param {import('react').ReactNode} props.title
 * @param {import('react').ReactNode} [props.children]
 * @param {import('react').ReactNode} [props.rightElement]
 * @param {string | null} [props.htmlFor]
 */
const InputLabel = ({title, children, rightElement, htmlFor = null}) => {
    return ( 
        <Form.Group className={title?'mb-3 ':''}>
            <div className="d-flex  justify-content-between">
            <label className={`no-select form-label text-secondary ${title?'':'d-none'}`}  
                htmlFor={htmlFor}>
                <span>{title} </span>
                </label>
                {rightElement}
            </div>
            
            {children}
      </Form.Group>  
    )
}
 
export default InputLabel; 